<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  // Apply styles to all buttons and links
  function styleButtons() {
    document.querySelectorAll(
      'button.product-form__submit, button.button--primary, button.button-ATC, a.button-ATC'
    ).forEach((button) => {
      // Base styles
      button.style.borderRadius = '25px';
      button.style.padding = '12px 24px';
      button.style.background = 'linear-gradient(90deg, #1b4e9b, #275aad)'; // Gradient background
      button.style.color = '#ffffff'; // White text
      button.style.border = 'none'; // Remove border
      button.style.display = 'inline-flex';
      button.style.alignItems = 'center';
      button.style.justifyContent = 'center';
      button.style.fontWeight = 'bold'; // Bold text
      button.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)'; // Subtle shadow
      button.style.transition = 'all 0.3s ease'; // Smooth transitions
      button.style.textDecoration = 'none'; // Remove underline for links

      // Hover effects
      button.addEventListener('mouseover', function () {
        button.style.background = '#143d73'; // Darker blue on hover
        button.style.transform = 'scale(1.05)'; // Slight zoom effect
      });

      button.addEventListener('mouseout', function () {
        button.style.background = 'linear-gradient(90deg, #1b4e9b, #275aad)'; // Revert background
        button.style.transform = 'scale(1)'; // Revert zoom effect
      });
    });
  }

  // Initial button styling
  styleButtons();

  // Handle dynamically added buttons (for SPA or AJAX-loaded content)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      styleButtons();
    });
  });

  // Observe the body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Function to adjust the sticky header's z-index when a popup is open
function adjustStickyHeaderForPopups() {
  const stickyHeader = document.querySelector('.sticky-header');
  const popups = document.querySelectorAll('.popup, .modal, [role="dialog"], .another-popup-class'); // Add common popup selectors here

  popups.forEach(popup => {
    // Detect when a popup is open
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
          if (popup.style.display === 'block' || popup.classList.contains('open')) {
            stickyHeader.style.zIndex = '10'; // Lower z-index when popup is open
          } else {
            stickyHeader.style.zIndex = '1000'; // Restore z-index when popup is closed
          }
        }
      });
    });

    // Observe changes to the popup's style or class
    observer.observe(popup, {
      attributes: true, // Watch for attribute changes
      attributeFilter: ['style', 'class'], // Only watch for style and class changes
    });
  });
}

// Run the function when the page loads
window.addEventListener('load', adjustStickyHeaderForPopups);

// Function to make the header sticky using JavaScript
function makeHeaderSticky() {
  const stickyHeader = document.querySelector('.sticky-header');
  const headerOffset = stickyHeader.offsetTop;

  window.addEventListener('scroll', () => {
    if (window.scrollY > headerOffset) {
      stickyHeader.style.position = 'fixed';
      stickyHeader.style.top = '0';
    } else {
      stickyHeader.style.position = 'static';
    }
  });
}

// Run the function when the page loads
window.addEventListener('load', makeHeaderSticky);


